import { panelBackupLate } from '@cp/shared';
import type { StatusPresentation } from '@/utils/labels';

/** The panel's own newest backup, as the API reports it, judged by the rule the alerts use. */
export function panelBackupStale(backup: { readonly at: string } | null, now = Date.now()): boolean {
  return panelBackupLate(backup ? new Date(backup.at) : null, new Date(now));
}

/** Copies made as a way back from a change: kept a week outside the slots (ADR-0056). */
const SAFETY_KINDS = new Set(['pre_deploy', 'pre_restore', 'pre_migrate', 'import']);

/** «Копия 2», or what a copy outside the slots is. */
export function backupSlotLabel(copy: { readonly slot: number | null; readonly verification: string; readonly kind: string }): string {
  if (copy.slot !== null) return `Копия ${copy.slot}`;
  if (copy.verification === 'pending') return 'Новая копия · проверяется';
  if (copy.verification === 'failed') return 'Не удалась';
  if (SAFETY_KINDS.has(copy.kind)) return 'Страховочная копия';
  return 'Вне слотов';
}

/** What is wrong with a site's copies. */
export const BACKUP_PROBLEM: Record<string, StatusPresentation> = {
  failed: { tone: 'down', label: 'Копия не удалась', glyph: '■', hint: 'Последняя попытка сделать копию не прошла' },
  none: { tone: 'degraded', label: 'Копий нет', glyph: '▲', hint: 'Проверенных копий пока нет' },
  stale: { tone: 'degraded', label: 'Копия устарела', glyph: '▲', hint: 'Последняя проверенная копия старше, чем требует расписание' },
  unprotected: { tone: 'unknown', label: 'Сервер не подключён', glyph: '○', hint: 'Подключите сервер сайта — копии пойдут по расписанию' },
  ok: { tone: 'healthy', label: 'В порядке', glyph: '●', hint: 'Свежая проверенная копия есть' },
};
